export const quizQuestions = [
  {
    id: "question16",
    videoId: "video16",
    topic: "FPV",
    question: "How much is the fine for driving without a valid license?",
    options: ["10,000 php", "3,000 ph", "1,000 php"],
    correctAnswer: "3,000 ph",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
];
